import React from 'react';
import { categoryTrackLabel, categoryUrl, HELP_LIST_TRACK_CAT, LinkWithHelpHighlight } from '../util';
import styled, { css } from 'styled-components';
import { spacer16, spacer8 } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';
import { SearchBar } from '../../Search';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SearchBarWrapper = styled.div.withConfig({
  displayName: "HelpListSideMenu__SearchBarWrapper",
  componentId: "sc-1t67kbv-0"
})([""]); // it seems the li needs to be styled, or else the ul inside will have a strange error

var SideMenuList = styled.ul.withConfig({
  displayName: "HelpListSideMenu__SideMenuList",
  componentId: "sc-1t67kbv-1"
})(["list-style:none;padding-left:0;"]);
var SideMenuItem = styled.li.withConfig({
  displayName: "HelpListSideMenu__SideMenuItem",
  componentId: "sc-1t67kbv-2"
})(["display:flex;flex-flow:row nowrap;align-items:center;padding:", " 0;border-bottom:1px solid ", ";&:last-child{border-bottom:none;}"], spacer16, function (_ref) {
  var theme = _ref.theme;
  return theme.help.link.divider;
});
var linkColors = css(["color:", ";"], function (_ref2) {
  var isCurrent = _ref2.isCurrent,
      theme = _ref2.theme;
  return isCurrent ? theme.help.sideMenu.selectedCategory : theme.help.sideMenu.unselectedCategory;
});
var SideMenuLink = styled(LinkWithHelpHighlight).withConfig({
  displayName: "HelpListSideMenu__SideMenuLink",
  componentId: "sc-1t67kbv-3"
})(["flex:1;-webkit-tap-highlight-color:transparent;", ""], linkColors);
var CategoryLabel = styled(Type).attrs({
  as: Type.span,
  variant: Type.heading4,
  weight: Type.bold
}).withConfig({
  displayName: "HelpListSideMenu__CategoryLabel",
  componentId: "sc-1t67kbv-4"
})([""]);
var CategoryCount = styled(Type).attrs({
  as: Type.span,
  variant: Type.heading4,
  weight: Type.book
}).withConfig({
  displayName: "HelpListSideMenu__CategoryCount",
  componentId: "sc-1t67kbv-5"
})(["flex:0;", ""], linkColors);
var CurrentCategoryIndicator = styled.div.withConfig({
  displayName: "HelpListSideMenu__CurrentCategoryIndicator",
  componentId: "sc-1t67kbv-6"
})(["flex:0;min-width:", ";height:", ";margin-right:", ";border-radius:50%;background-color:", ";"], spacer8, spacer8, spacer8, function (_ref3) {
  var theme = _ref3.theme;
  return theme.help.sideMenu.currentCategoryIndicator;
});
export var HelpListSideMenu = function HelpListSideMenu(_ref4) {
  var categories = _ref4.categories,
      currentCategory = _ref4.currentCategory;
  var t = useT();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SearchBarWrapper, {
      "data-testid": "help-search-bar",
      children: /*#__PURE__*/_jsx(SearchBar, {
        contentTypes: ['faq'],
        placeholder: t('FRODOR_e6f5ed', 'Search help articles', ''),
        suggestCount: 5,
        trackCategory: HELP_LIST_TRACK_CAT,
        getSuggestUrl: function getSuggestUrl(sug) {
          return "".concat(sug.url, "?ref=sug_").concat(HELP_LIST_TRACK_CAT).concat(currentCategory ? "&category=".concat(currentCategory.urlSlug) : '');
        }
      })
    }), /*#__PURE__*/_jsx(SideMenuList, {
      children: categories.map(function (category) {
        var isCurrent = category.urlSlug === (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.urlSlug);
        return /*#__PURE__*/_jsxs(SideMenuItem, {
          children: [isCurrent ? /*#__PURE__*/_jsx(CurrentCategoryIndicator, {
            "data-testid": "current-category-indicator"
          }) : null, /*#__PURE__*/_jsx(SideMenuLink, {
            track: [HELP_LIST_TRACK_CAT, categoryTrackLabel(category)],
            href: categoryUrl(category),
            isCurrent: isCurrent,
            children: /*#__PURE__*/_jsx(CategoryLabel, {
              children: category.name
            })
          }), /*#__PURE__*/_jsx(CategoryCount, {
            isCurrent: isCurrent,
            children: category.faqs.length
          })]
        }, category.urlSlug);
      })
    })]
  });
};